import React from 'react';
import Form from 'react-bootstrap/Form';

class AutomationModel extends React.Component {

  constructor(props) {
    super(props);
    this.state = { model: '', action: '', ...props.value };
  }

  UNSAFE_componentWillReceiveProps(props) { this.setState({ ...props.value }); }

  onChange = (field, val) => {
    const state = { ...this.state };
    state[field] = val;
    this.props.onChange(state);
    this.setState({ ...state });
  }

  render() {
    return (
      <div className="col-md-12">
        <div className="form-group col-md-12">
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'lead'}
              onChange={event => this.onChange('model', 'lead')} />
            <Form.Check.Label>{this.props.models.lead.model_name}</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'sales_order'}
              onChange={event => this.onChange('model', 'sales_order')} />
            <Form.Check.Label>{this.props.models.sales_order.model_name}</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'installment'}
              onChange={event => this.onChange('model', 'installment')} />
            <Form.Check.Label>{this.props.models.installment.model_name}</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'call'}
              onChange={event => this.onChange('model', 'call')} />
            <Form.Check.Label>{this.props.models.call.model_name}</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'meeting'}
              onChange={event => this.onChange('model', 'meeting')} />
            <Form.Check.Label>{this.props.models.meeting.model_name}</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'note'}
              onChange={event => this.onChange('model', 'note')} />
            <Form.Check.Label>{this.props.models.note.model_name}</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'project'}
              onChange={event => this.onChange('model', 'project')} />
            <Form.Check.Label>{this.props.models.project.model_name}</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'property'}
              onChange={event => this.onChange('model', 'property')} />
            <Form.Check.Label>{this.props.models.property.model_name}</Form.Check.Label>
          </Form.Check>
        </div>
        <div className="formhead col-md-12 p-0"><h4>Action</h4></div>
        <div className="form-group col-md-12">
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.action === 'add'}
              onChange={event => this.onChange('action', 'add')} />
            <Form.Check.Label>On Add</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.action === 'edit'}
              onChange={event => this.onChange('action', 'edit')} />
            <Form.Check.Label>On Update</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.action === 'add-edit'}
              onChange={event => this.onChange('action', 'add-edit')} />
            <Form.Check.Label>On Add/Update</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.action === 'delete'}
              onChange={event => this.onChange('action', 'delete')} />
            <Form.Check.Label>On Delete</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.action === 'none'}
              onChange={event => this.onChange('action', 'none')} />
            <Form.Check.Label>None</Form.Check.Label>
          </Form.Check>
        </div>
      </div>
    );
  }
}
export default AutomationModel;
